import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';

import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import { TargetedOffersContext } from 'contexts/TargetedOffersContext';

import { expiresSoonClosed, validateClosedBanners } from 'lib/targetedOffers/Banners/closedBanners';

import Banner, { PROMO_EXPIRES } from '../../Components/Banner';
import { Label, Title } from '../Banners.styled';

import Button from 'components/buttons/Button';
import { getColorFont, getFontFamily } from '../utils';

import { BANNER_EXPIRES_SOON } from 'lib/targetedOffers/Banners/constants';

import { MULTIPLEEXPIRES } from './Constants';

import { getOfferInfo } from 'lib/targetedOffers/Offers';

const BannerExpires = ({ targetedOffer, multiple }) => {
	const [close, setClose] = useState(false);

	const { globalization, openFilters } = useContext(CruiseSearchContext);

	const { filtersDictionary, generalDictionary } = globalization?.dictionaries || {};
	const {
		actionSeeMyOffers,
		labelTargetedOffersExpiresTitleToday,
		labelTargetedOffersExpiresTitleSoon,
		actionTargetedOffersShopThisOffer,
		labelTargetedOffersAllGuestWithPromo,
		labelTargetedOffersExpiringSoon,
	} = filtersDictionary;

	const { labelDontMissOutOnTheseSavings } = generalDictionary;

	const { isMobile } = useContext(CruiseSelectionContext);

	const { applyTargetedOffer } = useContext(TargetedOffersContext);

	const { utagBannerLoad, constants, utagOfferApplied } = useContext(AnalyticsContext);

	const { TYPES_BANNER } = constants;

	const closedBanners = validateClosedBanners();

	const { title: titleOffer, perksInfo, couponCode, isExpireToday } = getOfferInfo(targetedOffer || {});

	const labelTitle = isExpireToday ? labelTargetedOffersExpiresTitleToday : labelTargetedOffersExpiresTitleSoon;

	const title = labelTitle.replace('{0}', titleOffer);
	const labelCode = labelTargetedOffersAllGuestWithPromo.replace('{0}', `<b>${couponCode}</b>`);

	function closeBanner() {
		if (multiple)
			expiresSoonClosed({
				code: MULTIPLEEXPIRES,
			});
		else expiresSoonClosed(targetedOffer);
		setClose(true);
	}

	useEffect(() => {
		if (!close) {
			const getTypeBanner = () => {
				if (multiple) return TYPES_BANNER.MULTIPLE_EXPIRES;
				else return isExpireToday ? TYPES_BANNER.EXPIRES_TODAY : TYPES_BANNER.EXPIRES_SOON;
			};
			utagBannerLoad(getTypeBanner());
		}
	}, [isExpireToday, TYPES_BANNER, utagBannerLoad, close, multiple]);

	const getTitle = (multiple) => (multiple ? labelTargetedOffersExpiringSoon : `${title}`);

	const { generalDescriptionSeparator: perkTexts } = perksInfo;

	const getContent = (multiple) => (multiple ? labelDontMissOutOnTheseSavings : `${perkTexts} ${labelCode}`);

	const getButtonLabel = (multiple) => (multiple ? actionSeeMyOffers : actionTargetedOffersShopThisOffer);

	const onClick = () => {
		if (multiple) {
			closeBanner();
			openFilters('qualifiers', 'singleFilter');
		} else {
			applyTargetedOffer(targetedOffer);
			utagOfferApplied(undefined, targetedOffer);
		}
	};

	const codeBanner = multiple ? MULTIPLEEXPIRES : targetedOffer?.code;

	const expiresMultipleWasClosed = closedBanners.some(
		(closedBanner) => closedBanner.promoCode === codeBanner && closedBanner.type === BANNER_EXPIRES_SOON,
	);

	if (expiresMultipleWasClosed) return null;

	if (close) return null;

	return (
		<>
			<Banner
				onClose={closeBanner}
				type={PROMO_EXPIRES}
				titleBanner={
					<Title $color={getColorFont(isMobile, PROMO_EXPIRES)} $fontFamily={getFontFamily(isMobile)}>
						{getTitle(multiple)}
					</Title>
				}
				contentBanner={
					<Label
						dangerouslySetInnerHTML={{
							__html: `${getContent(multiple)}`,
						}}
						$weight="400"
					/>
				}
				actionBanner={
					<Button secondary small onClick={onClick}>
						{getButtonLabel(multiple)}
					</Button>
				}
			/>
		</>
	);
};

BannerExpires.propTypes = {
	targetedOffer: PropTypes.any,
	multiple: PropTypes.any,
};

BannerExpires.defaultProps = {
	targetedOffer: {},
	multiple: true,
};

export default BannerExpires;
